import React, {useEffect, useState} from "react";
import {Button, Card, Input, message, Space, Table} from "antd";
import {getHostAddress} from "../../Tool/UtileFun"
import {getFileAddress} from "../../Tool/UtileFun"
import {TabButton} from "./TabButton";
import cookie from "react-cookies";

export function TaskTable(){


    useEffect(
        ()=>{
            findTaskAll()
            newFindTaskAll()
        },[]
    );


    const classId = "classID"


    const findTaskAll=()=>{
        fetch(
            "http://"+getHostAddress()+"/task/findByClassId",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({classId:cookie.load("classID")}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setTask(data)
                console.log("findALL")
                console.log(data)
            })
            .catch(error => message.error("error"+error));
    }

    const [newTask,setNewTask] = useState()
    const newFindTaskAll=()=>{
        fetch(
            "http://"+getHostAddress()+"/task/newFindByClassId",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({classId:cookie.load("classID")}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                console.log("-----------------------")
                console.log(data)
                setNewTask(data)
            })
            .catch(error => message.error("error"+error));
    }

    const searchStudent=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/task/findByRealNameLike",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({name:value,classId:cookie.load("classID")}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setTask(data)
            })
            .catch(error => message.error("error"+error));
    }

    const exportExcel=()=>{
        let token = "Bearer " + sessionStorage.getItem('token')
        fetch(
            "http://"+getHostAddress()+"/batchImportApi/exportResults",
            {
                method:'post',
                headers: {
                    'Content-type': 'application/json;charset=UTF-8',
                    'Authorization': token,
                },
                body:JSON.stringify({classId:cookie.load(classId)}),
            }).then(res => res.blob().then(blob => {
            console.log(res === undefined)
            let filename = res.headers.get('File-Name');
            console.log(filename)
            //let filename="test.xls"
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename);  //兼容ie10
            } else {
                let a = document.createElement('a');
                document.body.appendChild(a) //兼容火狐，将a标签添加到body当中
                let url = window.URL.createObjectURL(blob);   // 获取 blob 本地文件连接 (blob 为纯二进制对象，不能够直接保存到磁盘上)
                a.href = url;
                a.download = "成绩.xls";
                a.target='_blank'  // a标签增加target属性
                a.click();
                a.remove()  //移除a标签
                window.URL.revokeObjectURL(url);
            }
        }))
    }


    const [taskReal,setTaskReal] = useState()
    let allTask;
    const findByStudentIdAndAndExperimentID =(value)=>{
        let reData = []
        return fetch(
            "http://"+getHostAddress()+"/task/findByStudentIdAndAndExperimentID",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({studentId:value.studentId,classId:cookie.load("classID"),experimentId:value.experimentId}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setTaskReal(data)
                allTask =  data
                return data
            })
            .catch(error => message.error("error"+error));
    }


    const [task,setTask]=useState([]);

    const { Search } = Input;

    const handleDown = () =>{
        //XHRLoadLoadFile("http://localhost:8080/batchImportApi/download",{classId:"2"})
        exportExcel()
    }

    const testDown = () =>{

        let data = ['http://'+getFileAddress()+'/experimentResources/knowledgeLibrary/课程分析表.xlsx','http://'+getFileAddress()+'/experimentResources/knowledgeLibrary/讲义PPT.pptx'];
        for (let i = 0; i < data.length; i++) {
            // console.log(data[i])
            console.log(data[i])
            let aDom = document.createElement('a')//创建标签
            let evt = document.createEvent('HTMLEvents')//创建事件
            evt.initEvent('click', false, false)//初始化事件，绑定点击事件，不冒泡，不阻止浏览器默认行为
            aDom.download = '课程分析表'+i+'.xlsx'
            aDom.href = data[i];//对地址进行编码
            aDom.dispatchEvent(evt)//触发事件
            aDom.click()
            //aDom.remove()
        }

    }

    const columns = [
        {
            title: '序号',
            width:80,
            render:(text,record,index)=>`${index+1}`

        },
        {
            title: '学生',
            dataIndex: 'student',
            key: 'student',
        },
        {
            title: '实验',
            dataIndex: 'experiment',
            key: 'experiment',
        },
        {
            title: '班级',
            dataIndex: 'cclass',
            key: 'cclass',
        },
        {
            title: "得分",
            dataIndex: "score",
            key:"score",
        },
        {
            title: '操作',
            key: 'details',
            render: (taskInfo) => (
                <>
                    <Space size="middle">
                        <TabButton props={taskInfo}
                                   Event={()=>{
                                       findTaskAll()
                                       console.log("执行了")
                                   }}
                        ></TabButton>
                    </Space>
                </>
            ),
        },

    ];




    const columnss = [
        { title: 'Name', dataIndex: 'name', key: 'name' },
        { title: 'Age', dataIndex: 'age', key: 'age' },
        { title: 'Address', dataIndex: 'address', key: 'address' },
        {
            title: 'Action',
            dataIndex: '',
            key: 'x',
            render: () => <a>Delete</a>,
        },
    ];


    return(
        <Card title={"作业批改"}>
            <Search placeholder="输入学生名称搜索"
                    onSearch={value => searchStudent(value)}
                    enterButton
                    style={{width:500}}/>
            <Button onClick={handleDown}>导出成绩</Button>
            <Table
                columns={columns}
                dataSource={task}
                pagination={{
                    onChange: page => {
                        console.log(page);
                    },
                    pageSize: 5,
                }}
            ></Table>
        </Card>
    )
}
